import React from 'react';

import { ToastContainer } from './styles';
import ToastComponent from './ToastComponent';
import { useToast } from './ToastContext';

const ToastManager: React.FC = () => {
  const { toasts, hideToast } = useToast();

  return (
    <ToastContainer>
      {toasts.map((toast) => (
        <ToastComponent key={toast.id} toast={toast} onClose={hideToast} />
      ))}
    </ToastContainer>
  );
};

export default ToastManager;
